import { Home, Utensils, Settings, Star } from 'lucide-react';

export const MenuData = [
  {
    title: 'Início',
    url: '/admin/dashboard',
    icon: <Home size={18} />
  },
  {
    title: 'Cardápio',
    url: '/admin/cardapio',
    icon: <Utensils size={18} />
  },
  {
    title: 'Pratos Populares',
    url: '/admin/pratos-populares',
    icon: <Star size={18} />
  },
  {
    title: 'Home Hero',
    url: '/painelHeroAdmin',
    icon: <Star size={18} />
  },
  {
    title: 'Configurações',
    url: '/admin/configuracoes',
    icon: <Settings size={18} />
  }
];
